import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAxiosPrivate } from "../useAxiosPrivate";

export default function useHomeScreenImageQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    // Fetch a single image by ID
    const useHomeScreenImageQuery = (id) =>
        useQuery({
            queryKey: ["home-screen-image", id],
            queryFn: ({ queryKey }) => {
                const [, imageId] = queryKey;
                return axiosPrivate
                    .get(`home-screen-image/${imageId}/`)
                    .then(r => r.data);
            },
            enabled: !!id,
        });

    // Fetch all images (global list)
    const homeScreenImageListQuery = useQuery({
        queryKey: ["home-screen-image", "list"],
        queryFn: () =>
            axiosPrivate
                .get("home-screen-image/")
                .then(r => r.data),
    });

    // Fetch images for the current business
    const businessHomeScreenImageQuery = useQuery({
        queryKey: ["home-screen-image", "business"],
        queryFn: () =>
            axiosPrivate
                .get("home-screen-image/get_for_business/")
                .then(r => r.data),
    });

    // MUTATIONS ------------------------------------------------------

    // Create a new image
    const createHomeScreenImageMutation = useMutation({
        mutationFn: (data) =>
            axiosPrivate.post("home-screen-image/", data, {headers: {'Content-Type': 'multipart/form-data'}}).then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["home-screen-image"]);
        },
    });

    // Delete an image
    const deleteHomeScreenImageMutation = useMutation({
        mutationFn: (id) =>
            axiosPrivate.delete(`home-screen-image/${id}/`).then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["home-screen-image"]);
        },
    });

    return {
        // queries
        useHomeScreenImageQuery,
        homeScreenImageListQuery,
        businessHomeScreenImageQuery,

        // mutations
        createHomeScreenImageMutation,
        deleteHomeScreenImageMutation,
    };
}
